// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3xW6T","buttons":"SendReceipts_buttons__2US4B","email":"SendReceipts_email__2cxWV","bookApptTitle":"SendReceipts_bookApptTitle__3PkI0"};